/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from 'prop-types';
import React from 'react';

import { useNavigate } from 'react-router-dom';

import { NavMenuButton } from '../../icons/NavMenuButton';
import { Button } from '../Button';
import { Link } from '../Link';
import { Logo } from '../Logo';
import './style.css';

import { LogoPartner } from '../LogoPartner';

import LoginStore from '../../stores/LoginStore';

export const AdminHeader = ({
    style,
    className,
    logoDimensions,
    shareFeedbackEmailAddress,
}) => {
    const navigate = useNavigate();

    const loginStore = LoginStore((state) => state);

    /*
	align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex: 0 0 auto;
    flex-wrap: wrap;
    gap: 64px 64px;
    justify-content: end;
    position: relative;
    width: 100%;
*/
    return (
        <div className={`admin-header ${className}`}>
            <div className={`frame ${style}`}>
                <div
                    className="logo-wrapper"
                    style={{ display: 'inline-block' }}
                >
                    <Logo
                        className="logo-instance"
                        logo="DUO"
                        logoDimensions={logoDimensions}
                        style={{
                            cursor: 'pointer',
                            colour: 'default',
                            float: 'left',
                        }}
                        onClick={() => {
                            navigate('/');
                        }}
                    />

                    <div
                        className="frame-32"
                        style={{
                            float: 'left',
                            justifyContent: 'start',
                            width: 'unset',
                            marginLeft: '3em',
                            position: 'relative',
                            lineHeight: '120px',
                        }}
                    >
                        <LogoPartner
                            className="design-component-instance-node-8"
                            color="default"
                            lernenDigital="/img/lernen-digital-transferstelle-anthrazit-rgb-1-2x.png"
                            partner="lernen-digital"
                            size="mobile"
                        />
                        <LogoPartner
                            className="design-component-instance-node-8"
                            color="black"
                            partner="uni-t-b"
                            size="mobile"
                        />
                    </div>
                </div>

                <div className="frame-2">
                    {style === 'desktop' && (
                        <div>
                            <div
                                style={{
                                    marginBottom: '25px',
                                    marginTop: '-65px',
                                }}
                            ></div>

                            <div className="frame-3">
                                <div className="frame-4">
                                    <Link
                                        className="instance-node"
                                        text="Resources"
                                        onClick={() => {
                                            navigate('/portalResource');
                                        }}
                                    />
                                    <Link
                                        className="instance-node"
                                        text="Authors"
                                        onClick={() => {
                                            navigate('/author');
                                        }}
                                    />
                                    <Link
                                        className="instance-node"
                                        text="Resource Types"
                                        onClick={() => {
                                            navigate('/resourceType');
                                        }}
                                    />
                                    <Link
                                        className="instance-node"
                                        text="School Types"
                                        onClick={() => {
                                            navigate('/schoolType');
                                        }}
                                    />
                                    <Link
                                        className="instance-node"
                                        text="Media Usage Goals"
                                        onClick={() => {
                                            navigate('/mediaUsageGoal');
                                        }}
                                    />
                                    <Link
                                        className="instance-node"
                                        text="FAQ Items"
                                        onClick={() => {
                                            navigate('/faqAdmin');
                                        }}
                                    />
                                    <Link
                                        className="instance-node"
                                        text="Server Settings"
                                        onClick={() => {
                                            navigate('/serverSettings');
                                        }}
                                    />
                                </div>

                                <Button
                                    className="instance-node"
                                    status="default"
                                    style="secondary"
                                    textLink="Logout"
                                    onClick={(e) => {
                                        loginStore.logout(() => {
                                            navigate('/');
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    {style === 'mobile' && (
                        <NavMenuButton className="nav-menu-button" />
                    )}
                </div>
            </div>
        </div>
    );
};

AdminHeader.propTypes = {
    style: PropTypes.oneOf(['desktop', 'mobile']),
};
